import $http from '../../utils/http';
// 公告信息
let appraise = 'tio/assess';
const getMainAssessInfo = params => {
    return $http({
        url: appraise + '/getMainAssessInfo',
        headers: { 'showLoading': false },
        params
    });
};

// 按季度查询州市排名接口
const getAssessScoreByQuarter = params => {
    return $http({
        url: appraise + '/getAssessScoreByQuarter',
        headers: { 'showLoading': false },
        params
    });
};

// 2.按季度查询州市排名信息接口
const getAssessScoreByDefault = params => {
    return $http({
        url: appraise + '/getAssessScoreByDefault',
        params
    });
};

// 3.按地区类型查询州市排名接口
const getAssessScoreByAreaType = params => {
    return $http({
        url: appraise + '/getAssessScoreByAreaType',
        params
    });
};
// 4.按季度查询全省州市排名接口
const getAssessScoreByProvince = params => {
    return $http({
        url: appraise + '/getAssessScoreByProvince',
        params
    });
};
// 5.根据考核项查询考核明细接口
const getSubAssessScoreByArea = params => {
    return $http({
        url: appraise + '/getSubAssessScoreByArea',
        params
    });
};
// 6.根据考核明细查详情接口
const getAssessDetailById = params => {
    return $http({
        url: appraise + '/getAssessDetailById',
        params
    });
};

// 7.考核评分细则接口
const getAssessRule = params => {
    return $http({
        url: appraise + '/getAssessRule',
        params
    });
};

// 5分钟未响应投诉列表
const notRespondDetail = params => {
    return $http({
        url: '/tio/complain/lyzhjgkp/notRespondDetail',
        params
    });
};
// 24小时未办结投诉列表
const notFinishedDetail = params => {
    return $http({
        url: '/tio/complain/lyzhjgkp/notFinishedDetail',
        params
    });
};

export default {
    getMainAssessInfo,
    getAssessScoreByQuarter,
    getAssessScoreByDefault,
    getAssessScoreByAreaType,
    getAssessScoreByProvince,
    getSubAssessScoreByArea,
    getAssessDetailById,
    notRespondDetail,
    notFinishedDetail,
    getAssessRule
};